export enum PROPERTY_TYPE {
	ROOM = 'ROOM',
	OTHER_ROOM = 'OTHER_ROOM', // Room
	OTHER = 'OTHER', // Room
	UPDATE = 'UPDATE',
	FEATURE = 'FEATURE',
	SKETCH = 'SKETCH',
	EXTERIOR = 'EXTERIOR',
	LOCATION = 'LOCATION',
	STREET_ADDRESS = 'STREET_ADDRESS'
}

export enum SECTION_TYPE {
	EXTERIOR = 'exterior',
	INTERIOR = 'interior'
}

export enum ROOM_POSITION {
	INTERIOR = 'Interior',
	EXTERIOR = 'Exterior'
}
